export default "__VITE_ASSET__65ef2236__"